import { AlignCenter } from "react-feather";
import { useNavigate } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import { useEffect, useState } from "react";
import { useLogout } from "../hooks/useLogout";
import { useDebugValue } from "react";
import { useNotifications } from "../hooks/useNotifications";
import { useRealTimeNotifications } from "../hooks/useRealTimeNotifications";
import apiClient from "../api/axios";
import SafeImage from "../components/common/SafeImage";
import logo1 from "../assets/img/img.png";
import logo1White from "../assets/img/img.png";

export default function PageHeader(prop) {
  const navigate = useNavigate();
  const { data: user } = useUser();
  const {
    data: notifications,
    isLoading: notificationsLoading,
    refetch: refetchNotifications,
  } = useNotifications();
  const { isConnected } = useRealTimeNotifications();

  const markAsRead = async (notificationId) => {
    try {
      await apiClient.put(`/notifications/${notificationId}/read`);
      refetchNotifications();
    } catch (error) {
      console.error("Failed to mark notification as read:", error);
    }
  };

  const handleNotificationClick = async (notification) => {
    console.log("Notification clicked:", notification);

    // Mark as read and delete the notification
    try {
      if (!notification.is_read) {
        await markAsRead(notification.id);
      }
      // Delete the notification to clear it from the list
      await apiClient.delete(`/notifications/${notification.id}`);
      refetchNotifications();
    } catch (error) {
      console.error("Failed to clear notification:", error);
    }

    // Smart routing based on user role and notification content
    let targetPath = notification.link;

    if (
      notification.message.includes("New order") &&
      (user?.role === "admin" || user?.role === "employee")
    ) {
      targetPath = "/order"; // Order list page for admins
    } else if (
      notification.message.includes("delivery assignment") &&
      user?.role === "driver"
    ) {
      targetPath = "/delivery"; // Delivery page for drivers
    } else if (notification.message.includes("Your order")) {
      // Extract order ID from message and go to order details
      const orderMatch = notification.message.match(/#(\d+)/);
      if (orderMatch) {
        targetPath = `/orderdeatils/${orderMatch[1]}`;
      }
    }

    if (targetPath && targetPath !== "#") {
      console.log("Navigating to:", targetPath);
      navigate(targetPath);
    }
  };

  const clearAllNotifications = async () => {
    try {
      const notificationIds = notifications?.map((n) => n.id) || [];
      await Promise.all(
        notificationIds.map((id) => apiClient.delete(`/notifications/${id}`)),
      );
      refetchNotifications();
    } catch (error) {
      console.error("Failed to clear notifications:", error);
    }
  };
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const logoutMutation = useLogout();

  // Load theme from localStorage on component mount
  useEffect(() => {
    const savedTheme = localStorage.getItem("darkTheme");
    const isDark = savedTheme === "true";
    setIsDarkTheme(isDark);

    // Apply theme to document
    if (isDark) {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDarkTheme;
    setIsDarkTheme(newTheme);
    // Save to localStorage
    localStorage.setItem("darkTheme", newTheme.toString());

    // Apply theme to document
    if (newTheme) {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
    window.dispatchEvent(
      new CustomEvent("onToastDark", {
        detail: { theme: newTheme ? "dark" : "light" },
      }),
    );
  };

  const handleLogout = () => {
    logoutMutation.mutate();
    navigate("/");
  };

  const getUserType = () => {
    if (!user) return "";
    switch (user.role) {
      case "admin":
        return "Admin";
      case "vendor":
        return "Vendor";
      case "employee":
        return "Employee";
      default:
        return "";
    }
  };

  const getProfileImage = () => {
    if (!user) return "/avatar-placeholder.png";
    if (user.profile_image && user.profile_image.startsWith("/")) {
      const baseUrl = import.meta.env.VITE_API_URL || "http://localhost:8000";
      const cleanedBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
      return `${cleanedBaseUrl}${user.profile_image}`;
    }
    return user.profile_image || "/avatar-placeholder.png";
  };

  const getProfileSettingsUrl = () => {
    if (!user) return "#";
    switch (user.role) {
      case "admin":
        return "/admin-profile-settings";
      case "employee":
        return "/employee-profile-settings";
      case "driver":
        return "/driver-profile-settings";
      case "vendor":
        return "/vendor-profile-settings";
      default:
        return "#";
    }
  };

  return (
    <>
      {/* <!-- Page Header Start--> */}
      <div ref={prop.headerRef} className="page-header">
        <div className="header-wrapper m-0">
          <div className="header-logo-wrapper p-0">
            <div className="logo-wrapper">
              <a href="/">
                <SafeImage
                  className="img-fluid main-logo"
                  src={logo1}
                  alt="logo1"
                />
                <SafeImage
                  className="img-fluid white-logo"
                  src={logo1White}
                  alt="logo2"
                />
              </a>
            </div>
            <div ref={prop.toggleSidebarRef} className="toggle-sidebar">
              <i
                className="status_toggle middle sidebar-toggle"
                data-feather="align-center"
              ></i>
              <AlignCenter
                className="status_toggle middle sidebar-toggle"
                onClick={prop.toggleSidebar}
              />
            </div>
          </div>

          {/* <form className="form-inline search-full" action="javascript:void(0)" method="get">
                    <div className="form-group w-100">
                        <div className="Typeahead Typeahead--twitterUsers">
                            <div className="u-posRelative">
                                <input className="demo-input Typeahead-input form-control-plaintext w-100" type="text"
                                    placeholder="Search Go Home Express .." name="q" title="" autoFocus/>
                                <i className="close-search" data-feather="x"></i>
                                <div className="spinner-border Typeahead-spinner" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div className="Typeahead-menu"></div>
                        </div>
                    </div>
                </form> */}
          <div className="nav-right col-6 pull-right right-header p-0">
            <ul className="nav-menus">
              <li>
                <span className="header-search">
                  <i className="ri-search-line"></i>
                </span>
              </li>
              <li className="onhover-dropdown">
                <div className="notification-box">
                  <i
                    className="ri-notification-line"
                    style={{ color: isConnected ? "#28a745" : "#6c757d" }}
                  ></i>
                  {notifications?.filter((n) => !n.is_read).length > 0 && (
                    <span className="badge rounded-pill badge-theme">
                      {notifications.filter((n) => !n.is_read).length}
                    </span>
                  )}
                </div>
                <ul
                  className="notification-dropdown onhover-show-div"
                  style={{ minWidth: "350px", maxWidth: "400px" }}
                >
                  <li
                    style={{
                      padding: "12px 16px",
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <i
                        className="ri-notification-line"
                        style={{ color: "white", marginRight: "8px" }}
                      ></i>
                      <h6 className="f-18 mb-0" style={{ color: "white" }}>
                        Notifications
                      </h6>
                    </div>
                    <button
                      className="btn btn-sm"
                      onClick={clearAllNotifications}
                      style={{
                        fontSize: "11px",
                        padding: "4px 8px",
                        background: "transparent",
                        border: "1px solid white",
                        color: "white",
                        borderRadius: "4px",
                      }}
                    >
                      Clear All
                    </button>
                  </li>
                  {notificationsLoading ? (
                    <li>
                      <p className="text-center">
                        <i className="fa fa-spinner fa-spin me-2"></i>Loading...
                      </p>
                    </li>
                  ) : notifications && notifications.length > 0 ? (
                    notifications.slice(0, 4).map((notification) => {
                      const timeAgo = (date) => {
                        const now = new Date();
                        const notificationDate = new Date(date);
                        const diffInMinutes = Math.floor(
                          (now - notificationDate) / (1000 * 60),
                        );

                        if (diffInMinutes < 1) return "now";
                        if (diffInMinutes < 60) return `${diffInMinutes}m`;
                        if (diffInMinutes < 1440)
                          return `${Math.floor(diffInMinutes / 60)}h`;
                        return `${Math.floor(diffInMinutes / 1440)}d`;
                      };

                      return (
                        <li key={notification.id}>
                          <p
                            style={{
                              margin: "8px 0",
                              fontSize: "13px",
                              lineHeight: "1.4",
                            }}
                          >
                            <i
                              className={`fa fa-circle me-2 ${notification.is_read ? "font-secondary" : "font-primary"}`}
                            ></i>
                            <span
                              onClick={() =>
                                handleNotificationClick(notification)
                              }
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                fontWeight: notification.is_read
                                  ? "normal"
                                  : "500",
                                cursor: "pointer",
                              }}
                            >
                              {notification.message}
                            </span>
                            <span
                              className="pull-right"
                              style={{ fontSize: "11px", color: "#888" }}
                            >
                              {timeAgo(notification.created_at)}
                            </span>
                          </p>
                        </li>
                      );
                    })
                  ) : (
                    <li>
                      <p className="text-center text-muted">
                        <i className="fa fa-bell-slash me-2"></i>No
                        notifications
                      </p>
                    </li>
                  )}
                </ul>
              </li>

              <li>
                <div
                  className="mode"
                  onClick={toggleTheme}
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className={isDarkTheme ? "ri-sun-line" : "ri-moon-line"}
                  ></i>
                </div>
              </li>
              <li
                className="profile-nav onhover-dropdown pe-0 me-0"
                style={{
                  position: "relative",
                  zIndex: 9999,
                }}
              >
                <div className="media profile-media">
                  <SafeImage
                    className="user-profile rounded-circle"
                    src={getProfileImage()}
                    alt=""
                  />
                  <div className="user-name-hide media-body">
                    <span>{user?.email || "User"}</span>
                    <p className="mb-0 font-roboto">
                      {getUserType()}
                      <i className="middle ri-arrow-down-s-line"></i>
                    </p>
                  </div>
                </div>
                <ul
                  className="profile-dropdown onhover-show-div"
                  style={{
                    zIndex: 10000,
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    minWidth: "160px",
                    background: isDarkTheme ? "#2f3640" : "#fffffff3",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: isDarkTheme
                      ? "1px solid #444"
                      : "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "8px 0",
                    margin: 0,
                    listStyle: "none",
                    transform: "translateZ(0)",
                  }}
                >
                  <li
                    style={{
                      padding: "8px 16px",
                      borderBottom: isDarkTheme
                        ? "1px solid #444"
                        : "1px solid #f0f0f0",
                    }}
                  >
                    <a
                      href={getProfileSettingsUrl()}
                      style={{
                        color: isDarkTheme ? "#fff" : "#333",
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                      }}
                    >
                      <i
                        className="ri-settings-3-line"
                        style={{
                          marginRight: "8px",
                          fontSize: "16px",
                          color: isDarkTheme ? "#ccc" : "#666",
                        }}
                      ></i>
                      <span>Settings</span>
                    </a>
                  </li>
                  <li
                    style={{
                      padding: "8px 16px",
                    }}
                  >
                    <a
                      onClick={() => setShowLogoutModal(true)}
                      style={{
                        color: isDarkTheme ? "#fff" : "#333",
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      <i
                        className="ri-logout-box-r-line"
                        style={{
                          marginRight: "8px",
                          fontSize: "16px",
                          color: isDarkTheme ? "#ccc" : "#666",
                        }}
                      ></i>
                      <span>Log out</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <!-- Page Header Ends--> */}

      {/* Logout Modal */}
      {showLogoutModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(5px)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "15px",
                border: "none",
                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                overflow: "hidden",
              }}
            >
              {/* Modal Header */}
              <div
                className="modal-header"
                style={{
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e9ecef",
                  padding: "1.5rem",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <span style={{ fontSize: "1.5rem" }}>⚠️</span>
                  <h5
                    className="modal-title"
                    style={{
                      margin: 0,
                      fontWeight: "600",
                      color: "#ffffffff",
                      fontSize: "1.3rem",
                    }}
                  >
                    Confirm Logout
                  </h5>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowLogoutModal(false)}
                  style={{
                    fontSize: "1.2rem",
                    padding: "8px",
                    backgroundColor: "rgba(0,0,0,0.1)",
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ✕
                </button>
              </div>

              {/* Modal Body */}
              <div
                className="modal-body"
                style={{
                  padding: "2rem 1.5rem",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "1.1rem",
                    color: "#555",
                    margin: 0,
                    lineHeight: "1.5",
                  }}
                >
                  Are you sure you want to logout?
                  <br />
                  <span style={{ fontSize: "0.9rem", color: "#888" }}>
                    You'll need to sign in again to access your account.
                  </span>
                </p>
              </div>

              {/* Modal Footer */}
              <div
                className="modal-footer"
                style={{
                  borderTop: "1px solid #e9ecef",
                  padding: "1.5rem",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setShowLogoutModal(false)}
                  style={{
                    padding: "12px 30px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    border: "none",
                    backgroundColor: "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#5a6268";
                    e.target.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#6c757d";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <span>↶</span> Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowLogoutModal(false);
                    handleLogout();
                  }}
                  style={{
                    padding: "12px 30px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    border: "none",
                    backgroundColor: "#dc3545",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#c82333";
                    e.target.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#dc3545";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <span>🚪</span> Yes, Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {logoutMutation.isLoading && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Logging out...</span>
                </div>
                <p className="mt-2">Logging out...</p>
              </div>
            </div>
          </div>
        </div>
      )}
      {logoutMutation.isError && (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}
        >
          Logout failed. Please try again.
        </div>
      )}
    </>
  );
}
